import clsx from 'clsx'
import LazyLoad from 'react-lazyload'

import { Container } from 'src/components/Container/Container'

import styles from './Video.module.scss'
import { VideoIframe } from './VideoIframe'

import type { VideoModule } from 'src/types/Module'

export const Video = ({ video, fullWidth }: VideoModule) => {
  const videoRgx = String(video).match(/youtube.com\/(embed\/|watch\?v=)((\w|-|_)+)/)
  const videoKey = videoRgx ? videoRgx[2] : ''
  const url = `https://www.youtube-nocookie.com/embed/${videoKey}`

  return (
    <Container className={clsx(fullWidth && styles.wide)}>
      <div className={styles.video}>
        <LazyLoad height={315} offset={500} once>
          <VideoIframe url={url} />
        </LazyLoad>
        <noscript>
          <VideoIframe url={url} />
        </noscript>
      </div>
    </Container>
  )
}
